var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMicrochipCat = function SvgMicrochipCat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 56 56"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Microchip-Cat_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#B4EEF3",
    d: "M28 3.5c13.532 0 24.5 10.969 24.5 24.5S41.532 52.5 28 52.5 3.5 41.532 3.5 28 14.469 3.5 28 3.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007C83",
    d: "M34.67 53.862H17.837a7.47 7.47 0 0 1-7.473-7.473V20.106h10.185c11.708 0 21.193 9.485 21.193 21.192v5.495a7.073 7.073 0 0 1-7.07 7.07"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007C83",
    d: "M23.786 49.645H22.3v-8.417c0-5.285 4.077-9.678 9.345-10.098.402-.035.77.28.787.7v.053a.73.73 0 0 1-.7.735c-4.48.367-7.945 4.112-7.945 8.61z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00484E",
    d: "m6.022 2.693.175 8.907 9.31-5.372-7.612-4.62a1.23 1.23 0 0 0-1.873 1.085M27.62 2.693l-.174 8.907-9.31-5.372 7.612-4.62a1.23 1.23 0 0 1 1.873 1.085"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007C83",
    d: "M16.82 26.667c6.205 0 11.235-5.03 11.235-11.235S23.025 4.197 16.82 4.197 5.585 9.227 5.585 15.432s5.03 11.235 11.235 11.235"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00484E",
    d: "m15.664 19.129-.945-1.33c-.455-.63-.297-1.523.333-1.978.245-.175.525-.262.822-.262h1.873c.787 0 1.417.63 1.417 1.417 0 .298-.087.578-.262.823l-.945 1.33a1.423 1.423 0 0 1-2.31 0zM41.738 42.61a7.073 7.073 0 0 1-7.07 7.07H16.083c-2.94 0-5.32-2.38-5.32-5.337v-.122a5.396 5.396 0 0 1 5.425-5.198h1.645a2.114 2.114 0 0 0 2.118-2.117 2.114 2.114 0 0 0-2.118-2.118h-1.75c-5.285 0-9.572 4.305-9.555 9.59v.123c.088 5.25 4.463 9.415 9.713 9.415h17.85l.595-.053a7.073 7.073 0 0 0 7.07-7.07v-4.182zM12.493 14.56a1.45 1.45 0 0 1-1.453-1.452c0-.805.648-1.453 1.453-1.453.804 0 1.452.648 1.452 1.453s-.648 1.452-1.453 1.452M21.42 14.56a1.45 1.45 0 0 1-1.452-1.452c0-.805.647-1.453 1.452-1.453s1.453.648 1.453 1.453-.648 1.452-1.453 1.452"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003E52",
    d: "M29.366 28.003a.9.9 0 0 1-.647-.263l-1.803-1.802c-.35-.35-.332-.928 0-1.278.333-.35.91-.35 1.278 0l1.802 1.802a.89.89 0 0 1 .193.98.92.92 0 0 1-.84.56z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F04B24",
    d: "M47.935 24.902a.904.904 0 0 1-.91-.91c0-7.647-4.585-14.56-11.638-17.517a.9.9 0 0 1-.472-1.19c.21-.455.735-.683 1.19-.473a20.835 20.835 0 0 1 12.74 19.198c0 .507-.403.91-.91.91z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F04B24",
    d: "M44.313 24.903a.904.904 0 0 1-.91-.91 15.29 15.29 0 0 0-9.678-14.28.92.92 0 0 1-.56-.718.89.89 0 0 1 .333-.84.91.91 0 0 1 .892-.122 17.12 17.12 0 0 1 10.815 15.96c0 .507-.402.91-.91.91z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F04B24",
    d: "M40.686 24.903a.904.904 0 0 1-.91-.91c0-4.917-3.08-9.327-7.7-11.042a.904.904 0 0 1-.613-.998.92.92 0 0 1 1.208-.717 13.64 13.64 0 0 1 8.907 12.757c0 .508-.402.91-.91.91z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F04B24",
    d: "M37.065 24.9a.904.904 0 0 1-.91-.91 8.13 8.13 0 0 0-5.757-7.787.88.88 0 0 1-.613-.665.91.91 0 0 1 .262-.857c.228-.21.578-.298.875-.21a9.95 9.95 0 0 1 7.036 9.52c0 .507-.403.91-.91.91z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Microchip-Cat_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h56v56H0z"
  })))));
};
export default SvgMicrochipCat;